<template>
  <div class="result-warpper">
    <div class="border"></div>
    <h1 v-show="applet.judgeModel != 1">
      <!-- <h1 v-show="applet.judgeModel != 1"> -->
      <span style="font-size: 12px">真品存档图案图与手机拍照图案对比</span><br /><br />
      <span :style="{ color: judgeResult == '相符' ? '#409eff' : 'red' }">{{
        judgeResult
      }}</span>
      <!-- {{ result.rate >= result.baseRate ? '相符' : '不相符' }} -->
    </h1>
    <div class="weili" :style="{ flexDirection: link.value == '2' ? 'column' : 'row' }">
      <div class="left" id="leftImg">
        <h2>真品存档图案</h2>
        <br />
        <img id="serviceImg" @load="imgLoad" style="transform: rotate(180deg)" :src="result.myWl[0].indexOf('http://') >= 0
          ? result.myWl[0]
          : 'http://47.95.37.145:8888' + result.myWl[0]
          " alt="" />
        <Grid :x="link.x ? parseInt(link.x) : 3" :y="link.y ? parseInt(link.y) : 2" :height="serverTableHeight" />
      </div>
      <div class="right">
        <h2>手机拍摄图案</h2>
        <br />
        <img id="iphoneImg" style="transform: rotate(180deg)" @load="imgLoad" :src="result.yourWl[0].indexOf('http://') >= 0
          ? result.yourWl[0]
          : 'http://47.95.37.145:8888' + result.yourWl[0]
          " alt="" />
        <Grid :x="link.x ? parseInt(link.x) : 3" :y="link.y ? parseInt(link.y) : 2" :height="iphoneTableHeight" />
      </div>
    </div>
    <!-- <div class="source">
      <div class="left">
        <h2>产品图</h2>
        <br />
        <img :src="applet.productImgUrl" alt="" />
      </div>
      <div class="right">
        <h2>手机拍摄图</h2>
        <br />
        <img :src="'http://47.95.37.145:8888' + result.fullPath" alt="" />
      </div>
    </div> -->
  </div>
</template>

<script>
import Grid from './components/grid'
export default {
  components: { Grid },
  props: {
    applet: {
      type: Object,
      default() {
        return {}
      }
    },
    judge: {
      type: String,
      default: ''
    },
    link: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      result: {},
      judgeResult: '',
      iphoneTableHeight: '150px',
      serverTableHeight: '150px'
    }
  },
  watch: {
    judge: function (a, b) {
      console.log('xxxxxx', a)
      this.judgeResult = a
    }
  },
  created() {
    // setTimeout(() => {
    //   console.log(this.$refs.serviceImg.style.height)
    // }, 1000);

    this.result = JSON.parse(sessionStorage.getItem("KSY_RESULT_" + this.$route.query.key))
    // console.log('人工', this.result)
    // console.log(this.result, this.applet)
    if (this.applet.judgeModel == '2') {
      this.judgeResult = ''
    }
    else if (this.applet.judgeModel == '2') { //人工

    } if (this.applet.judgeModel == '3') { //人工+自动
      if (this.result.rate >= this.result.baseRate) {
        this.judgeResult = '相符'
      }
    } if (this.applet.judgeModel == '4') {
      this.judgeResult = this.result.rate >= this.result.baseRate ? '相符' : '不相符'
    }
  },
  methods: {
    imgLoad(el) {
      // console.log(document.getElementById("serviceImg").offsetHeight)
      // this.$refs.serverTable.style.height = document.getElementById("serviceImg").offsetHeight + 'px'
      this.iphoneTableHeight = document.getElementById("iphoneImg").offsetHeight + 'px'
      this.serverTableHeight = document.getElementById("serviceImg").offsetHeight + 'px'
      // console.log(this.iphoneTableHeight, this.serverTableHeight)
      // this.$refs.iphoneTable.style.height = document.getElementById("iphoneImg").offsetHeight + 'px'
    }
  }
}
</script>

<style lang="scss" scoped>
.result-warpper {
  text-align: center;
  position: relative;
  padding: 0.5rem;
  padding-top: 0px;

  h1 {
    font-size: 0.56rem;
    padding: 0.32rem 0;
  }

  h2 {
    color: #515152;
    font-size: 0.4rem;
  }

  .border {
    border: 3px solid #525151bf;
    border-radius: 10px;
    position: absolute;
    left: 7px;
    top: -20px;
    z-index: 0;
    width: calc(100% - 20px);
    height: calc(100% + 20px);
  }

  .weili,
  .source {
    display: flex;

    .left,
    .right {
      flex: 1;
      padding: 0.32rem;

      img {
        height: calc(100% - 40px);
      }

      position: relative;

      table {
        position: absolute;
        // width: 87%;
        width: calc(100% - 0.63rem);
        // height: 80.5%;
        top: 40px;
        left: 12px;
      }
    }

    img {
      width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Result/index.vue